export default __webpack_public_path__ + "assets/images/arrow-d.341274e00418872f5a70de7d60f170b9.svg";